import {
  Box,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import MapIcon from '@material-ui/icons/Map';
import moment, { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GreenPinIcon from '../../../../assets/images/map-icons/green-pin.png';
import RedPinIcon from '../../../../assets/images/map-icons/red-pin.png';
import Card from '../../../../components/Card';
import CardMessage from '../../../../components/CardMessage/CardMessage';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import Map from '../../../../components/Map';
import { CondominiumCoordinatesDTO } from '../../../../models/dto/CondominiumDTO';
import { PeriodDTO } from '../../../../models/dto/PeriodDTO';
import { findCondominiumCoordinates } from '../../../../services/peopleManagement.service';
import { AppState } from '../../../../store';
import { getEmployeePunchCard } from '../../../../store/actions/employeesActions';
import { CondominiumReducerData } from '../../../../store/reducers/condominiumReducer';
import { EmployeesReducerData } from '../../../../store/reducers/employeesReducer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: '100%',
    },
    divider: {
      height: 40,
    },
    legend: {
      fontSize: 13,
    },
    mapContainer: {
      position: 'relative',
      marginTop: '8px',
      height: 'calc(100% - 58px)',
    },
    cardContentContainer: {
      height: 'calc(100% - 64px)',
      paddingBottom: theme.spacing(2),
    },
    loadingContainer: {
      height: 'calc(100% - 32px)',
    },
  }),
);

const GeolocationDetailCard: React.FC = () => {
  const classes = useStyles();
  const [dateSelected, setDateSelected] = useState<Moment | null>(moment());
  const [condominiumCoordinates, setCondominiumCoordinates] = useState<
    CondominiumCoordinatesDTO
  >();
  const [loading, setLoading] = useState<boolean>(false);
  const { employeeSelected }: EmployeesReducerData = useSelector(
    (state: AppState) => state.employeesReducer,
  );
  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );
  const [latLongMarks, setLatLongMarks] = useState<any>();

  const getCondominiumCoordinates = async (reference: number) => {
    const { data } = await findCondominiumCoordinates(reference);

    setCondominiumCoordinates(data);
  };

  useEffect(() => {
    async function getPunchCard() {
      if (employeeSelected && dateSelected?.isValid()) {
        setLoading(true);
        const data = await getEmployeePunchCard(employeeSelected, {
          inicioMesApuracao: dateSelected?.format('DD/MM/YYYY'),
          fimMesApuracao: dateSelected?.format('DD/MM/YYYY'),
        } as PeriodDTO);

        if (data) {
          const logDistancesFmt = data
            .map(item => item.logDistancia)
            ?.filter(item => item !== null && item !== undefined)
            .flat();

          if (logDistancesFmt && logDistancesFmt.length > 0) {
            setLatLongMarks(
              logDistancesFmt.map(log => [log.latitude, log.longitude]),
            );
          } else {
            setLatLongMarks([]);
          }
        }
        setLoading(false);
      }
    }

    getPunchCard();
  }, [employeeSelected, dateSelected]);

  useEffect(() => {
    if (condominiumSelected) {
      getCondominiumCoordinates(condominiumSelected.referencia);
    }
  }, [condominiumSelected]);

  return (
    <>
      <Card className={classes.card}>
        <CardHeader
          title={
            <Typography color="textSecondary" variant="h5">
              Últimos Locais
            </Typography>
          }
        />
        <CardContent className={classes.cardContentContainer}>
          <Grid container>
            <Grid item md={4}>
              <CustomDatePicker
                disableFuture
                id="dueDate"
                label="Data do Registro"
                value={dateSelected}
                disabled={!employeeSelected}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={value => setDateSelected(value)}
              />
            </Grid>
            <Grid container item md={8} justify="flex-end" alignItems="center">
              <Grid item>
                <Typography className={classes.legend}>
                  <img src={RedPinIcon} alt="Local do registro de ponto" />{' '}
                  Registro de Ponto
                </Typography>
              </Grid>
              <Divider
                className={classes.divider}
                orientation="vertical"
                variant="middle"
              />
              <Grid item>
                <Typography className={classes.legend}>
                  <img src={GreenPinIcon} alt="Local de login" />
                  Login
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {employeeSelected ? (
            <>
              {loading ? (
                <Grid
                  container
                  className={classes.loadingContainer}
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={2}>
                    <CircularProgress color="primary" />
                  </Grid>
                </Grid>
              ) : (
                <>
                  {latLongMarks?.length > 0 ? (
                    <Box className={classes.mapContainer}>
                      <Map
                        centerMark={[
                          condominiumCoordinates?.latitude,
                          condominiumCoordinates?.longitude,
                        ]}
                        marks={latLongMarks}
                      />
                    </Box>
                  ) : (
                    <CardMessage
                      icon={<MapIcon style={{ fontSize: 130, opacity: 0.4 }} />}
                      message="As coordenadas não foram encontradas."
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <CardMessage
              icon={<MapIcon style={{ fontSize: 130, opacity: 0.4 }} />}
              message="Selecione um funcionário"
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default GeolocationDetailCard;
